// Mirrors lets-launch-backend/constants/limits.js. Keep in sync.
//
// When a workspace's Plan has a limit field set to `undefined`, the backend
// resolves it via these constants. The UI mirrors them to render the
// "default" hint to admins.

export type LimitEngine = 'heygen' | 'videoAgent' | 'promptToVideo' | 'avatars';

export interface PlanLimitSet {
  heygen: number;
  videoAgent: number;
  promptToVideo: number;
  avatars: number;
}

export const PLAN_LIMITS: {
  free: PlanLimitSet;
  starter: PlanLimitSet;
  pro: PlanLimitSet;
  customDefault: PlanLimitSet;
  fullAccess: PlanLimitSet;
} = {
  free:          { heygen: 10,       videoAgent: 10,       promptToVideo: 10,  avatars: 0 },
  starter:       { heygen: 30,       videoAgent: 30,       promptToVideo: 60,  avatars: 10 },
  pro:           { heygen: 100,      videoAgent: 100,      promptToVideo: 100, avatars: 50 },
  customDefault: { heygen: 100,      videoAgent: 100,      promptToVideo: 100, avatars: 50 },
  fullAccess:    { heygen: Infinity, videoAgent: Infinity, promptToVideo: 500, avatars: Infinity },
} as const;
